module.exports = __webpack_public_path__ + "img/60.a659cb63.jpg";